// ngx-mask format: 0 = digit, A = alphanumeric, S = letter
const CPF_LENGTH: number = 11;

// CPF: 000.000.000-00
export const cpfMask: string = '000.000.000-00';

export const alphanumericCnpjMask: string = 'AA.AAA.AAA/AAAA-00';

// Máscara dinâmica CPF/CNPJ - ngx-mask usa padrão dinâmico com ||
// Formato: máscara menor || máscara maior (ordem por tamanho)
export const cpfCnpjMask: string = '000.000.000-00||AA.AAA.AAA/AAAA-00';
